import { useMemo } from 'react';

import { useCurrentLocale } from 'contexts/CurrentLocaleContext';
import { createI18nFnForLocale } from 'i18n/createI18nFnForLocale';

export function useI18n() {
  const { currentLocale } = useCurrentLocale();

  const i18n = useMemo(
    () => createI18nFnForLocale(currentLocale),
    [currentLocale],
  );

  return { i18n };
}
